/**
 * This serves as a DTO that is accepted as the "data" prop for the AudienceList component.
 */
export class AudienceListData {
  rows = [];

  getRows() {
    return this.rows;
  }

  addRow(
    id,
    name,
    scope,
    scopeDisplay,
    assignments,
    createdBy,
    createdAt,
    updatedAt
  ) {
    this.rows.push({
      id,
      name,
      scope,
      scopeDisplay,
      assignments,
      createdAt,
      createdBy,
      updatedAt,
    });
  }
}
